"use client";
import React, { useState, ChangeEvent, FormEvent } from "react";
import Link from "next/link";

import { RootState } from "@/app/GlobalRedux/Store";
import { useSelector } from "react-redux";
// icons
import { RiErrorWarningFill } from "react-icons/ri";

import styling from "@/app/auth/Components/GeneralAuth.module.scss";
import { regex } from "@/app/utils/forms-utils/regex";
import { ResetToken } from "@/app/GlobalRedux/features/auth/authInterfaces";
import AuthHeader from "../../Components/AuthHeader";
import { useForgetPasswordEmailResetTokenMutation } from "@/app/GlobalRedux/features/auth/authApi";

interface FormValues {
  email: string;
}

const INITIAL_STATE: FormValues = {
  email: "",
};

const validate = (formValues: FormValues) => {
  // Initialize errors object with the same shape as FormValues
  const errors: Partial<FormValues> = {};

  if (!formValues.email) {
    errors.email = "Email field can't be empty!";
  } else if (!regex.test(formValues.email)) {
    errors.email =
      "Please enter your email address in format: yourname@example.domain!";
  } else if (formValues.email.length <= 12) {
    errors.email = "Please provided a properly formatted email address!";
  }

  return errors;
};

const VerifyEmail = () => {
  // const dispatch = useDispatch();

  const theme = useSelector((state: RootState) => state.theme.themeValue);
  // const { isLoadingUser } = useSelector(
  //   (state: RootState) => state.auth
  // );

  const [forgetPasswordEmailResetToken, { isLoading: isLoadingUser }] =
    useForgetPasswordEmailResetTokenMutation();

  const [formValues, setFormValues] = useState<FormValues>(INITIAL_STATE);
  const { email } = formValues;
  const [formErrors, setFormErrors] = useState<FormValues>({} as FormValues);

  // error styling
  const emailInputClasses = formErrors.email ? "invalid" : "";

  const onFormChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    // console.log(value)
  };

  // SUBMIT FORM
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const errors = validate(formValues) as FormValues;
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      console.log(errors);
      return; // Stop code execution if there are errors
    }
    const Data: ResetToken = {
      email,
    };

    await forgetPasswordEmailResetToken(Data).unwrap();
    // await dispatch(RESET());
  };

  return (
    <div
      className={`${styling.auth} ${theme === "dark" ? styling.darkMode : ""}`}
    >
      <AuthHeader />
      <main>
        <aside>
          <h1>Forgot Your Password?</h1>
          <p>No worries! We&apos;ll help you get back into your account.</p>
        </aside>
        <aside>
          <h4>Password Reset</h4>
          <p>
            Enter your email address below, and we&apos;ll send you instructions
            on how to reset your password. Please make sure to check your email
            after requesting a new code. <br /> And note that the link will
            EXPIRE WITHIN ONE HOUR of signing up for your new account.
            <br />
          </p>

          <p>
            Email can take up to 5 MINUTES TO ARRIVE due to traffic. If you
            don’t see the email in your inbox within 10 minutes, PLEASE CHECK
            YOUR SPAM FOLDER.
            <br />
          </p>
          <form noValidate onSubmit={handleSubmit}>
            <div className={emailInputClasses}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                value={formValues.email}
                onChange={onFormChange}
                placeholder="Enter your email address"
              />
            </div>

            {/* ERROR CONTAINER */}
            <div className={styling.error}>
              {formErrors.email && (
                <p>
                  <RiErrorWarningFill />
                  {formErrors.email}
                </p>
              )}
            </div>
            {/* ERROR CONTAINER ENDS*/}
            {isLoadingUser ? (
              <button type="submit">SENDING...</button>
            ) : (
              <button type="submit">SEND CODE</button>
            )}
          </form>

          <div className={styling.auth__Form__OR}>
            <p>
              Don&apos;t have an account?
              <span>
                <Link href="/auth/signup">Sign up</Link>
              </span>
            </p>
          </div>
        </aside>
      </main>
    </div>
  );
};

export default VerifyEmail;
